<template>
    <div id="feedback">
       <div class="g-right-top width800">个人中心／编辑资料／基本信息</div>
       <div class="g-right-middle margintop20 width800 g-ypxx">
             <p>
             	<span class='ypxx-left'>意见反馈</span>
             	<span class="ypxx-right">
             		<textarea v-model="feedback" class="g-wd-txt"></textarea><span style='vertical-align: top;margin-left: 10px;color: #999;'>限300字以内</span>

             	</span>
             	<div class="clearfix"></div>
             </p>
			 <center><input  type="button" class="g-btn" @click="updateinfor" value="确认提交"></center>
       </div>  
    </div>
</template>
<script>
	import Axios from 'axios'
	export default{
		data(){
			return{
				feedback:''
			}
		},
		methods:{
			updateinfor(){
				var api="http://api.yopoo.cn/api/v1/feedback"
				
				//需要加入时间限制来控制提交次数
				if(!this.feedback){
					this.$message({
						message: '您还未填写内容！',
						type: 'warning',
						center:true
						
					});
					return fasle
				}else{
					Axios.post(api,{feedback:this.feedback}).then((res)=>{
						// console.log(res)
						if(res.data.code==200){
							this.$message({
								message: res.data.msg,
								type: 'success',
								center:true
								
							});
						}
						if(res.data.code==202){
							this.$message({
								message: res.data.msg,
								type: 'error',
								center:true
								
							});
						}
					}).catch()
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/per_admin/P_Feedback.vue